var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41339",
    "data-name": "Group 41339",
    transform: "translate(-211 -918)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15684",
    "data-name": "Rectangle 15684",
    width: 40,
    height: 40,
    transform: "translate(211 918)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "download_2_",
    "data-name": "download (2)",
    d: "M99.547,30.994v3.527a.479.479,0,0,1-.479.479H76.59a.479.479,0,0,1-.479-.479V30.994a.479.479,0,0,1,.479-.479H99.068A.479.479,0,0,1,99.547,30.994Zm.586-15.487a.48.48,0,0,0-.442-.3H93.612V.479A.479.479,0,0,0,93.132,0H82.526a.479.479,0,0,0-.479.479V15.211H75.968a.479.479,0,0,0-.338.818l11.861,11.86a.477.477,0,0,0,.677,0l11.861-11.86a.481.481,0,0,0,.1-.522Z",
    transform: "translate(143.17 920.5)",
    fill: "#06a77d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.f1ea417df4023f046e8930a81851b537.svg";
export { ForwardRef as ReactComponent };